// removed by extract-text-webpack-plugin
module.exports = {"avatarList":"avatarList___PhBB9","avatarItem":"avatarItem___whbGi","avatarItemLarge":"avatarItemLarge___z4k9e","avatarItemSmall":"avatarItemSmall___2iaM8","avatarItemMini":"avatarItemMini___22B0-"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/AvatarList/index.less
// module id = 421
// module chunks = 0 1